import styled from 'styled-components';
import Button from '../../../styled/Button';
import { theme } from '../../../styled/layout/theme';
import { size } from '../../../styled/layout/helpers';

export const Container = styled.div`
  position: relative;
  overflow: hidden;
`;

export const Overlay = styled.div`
  text-align: center;
  position: absolute;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 32px;
  top: 50%;
  transform: translateY(-50%);

  & img {
    filter: drop-shadow(rgb(0, 0, 0) 0px 0px 15px);
  }
`;

export const Buttons = styled.div`
  display: flex;
  justify-content: center;
  gap: 16px;
`;

export const Btn = styled(Button)`
  width: 150px;

  &:hover {
    filter: brightness(0.9);
  }
`;

export const Img = styled.img`
  max-width: 100%;
  display: block;

  &.fade {
    position: absolute;
    top: 0;
    opacity: 0;
    transition: opacity 250ms linear;
  }

  &.show {
    opacity: 1;
  }
`;

export const ImageContainer = styled.div`
  overflow: hidden;
  height: 0;
`;

export const Message = styled.div`
  font-family: 'Bulldog Mio', 'Source Sans Pro', sans-serif;
  font-weight: 500;
  overflow: hidden;
  padding: ${size(3)} 0;

  ${theme.screens.LtMd} {
    padding: ${size(2)} 0;
  }
`;

export const MessageHeader = styled.div`
  font-family: 'Bulldog Mio', 'Source Sans Pro', sans-serif;
  font-weight: 600;
  line-height: 1;
  text-align: center;
`;

export const MessageSubHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0;
  text-align: center;
`;
